<div class="dialog-container">
    <div class="dialog-icon-container">
        <i class="bi bi-trash3"></i>
    </div>
    <h1 mat-dialog-title>Eliminar plantilla</h1>
    <div mat-dialog-content>
        <p class="delete-dialog-content">
            ¿Está seguro de eliminar la plantilla ({{data}}) definitivamente?
        </p>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="data">
            Si
        </button>
        <button mat-button (click)="onCancel()">
            No
        </button>
    </div>
</div>